import { type Context, createContext } from "react";

export interface ModalRegistration {
  id: number;
  depth: number;
}

export interface ModalRegistrationOptions {
  lockBodyScroll?: boolean;
}

export interface ModalContextValue {
  readonly modalDepth: number;
  readonly isModalOpen: boolean;
  registerModal: (
    closeHandler: () => void,
    options?: ModalRegistrationOptions,
  ) => ModalRegistration;
  unregisterModal: (id: number) => void;
  closeAllModals: () => void;
}

export const ModalContext: Context<ModalContextValue> =
  createContext<ModalContextValue>({
    modalDepth: 0,
    isModalOpen: false,
    registerModal: (): ModalRegistration => ({ id: 0, depth: 0 }),
    unregisterModal: (): void => {},
    closeAllModals: (): void => {},
  });
